module.exports = __webpack_public_path__ + "img/balt-logo-white.10882f52.png";